import {useEffect, useRef} from 'react'
import {AppLoading} from '../../../_metronic/helpers/components/AppLoading'
import {useAuth} from './core/Auth'

export function Logout() {
  const {logout} = useAuth()
  const started = useRef(false)
  useEffect(() => {
    // Once: signing out re-renders the provider with a new logout. Leaving waits for the server to drop the session
    // cookie, or the next page would sign the user straight back in; replace, so «بازگشت» does not sign out again.
    if (started.current) return
    started.current = true
    logout().then(() => window.location.replace('/auth'))
  }, [logout])

  return <AppLoading mode='page' message='در حال خروج…' />
}
